// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dZLDdb6NwIUQCq0w{width:20px;height:20px;flex-shrink:0}.EcyLfg9Cw7MXNWxp{line-height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.NH14bviFasbRl5ZB{display:flex;align-items:center;justify-content:space-between;height:32px}.NH14bviFasbRl5ZB .nJDS02D6AU0YgibJ{display:flex;align-items:center;justify-content:flex-end;column-gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userAvatar": `dZLDdb6NwIUQCq0w`,
	"userName": `EcyLfg9Cw7MXNWxp`,
	"nameColumn": `NH14bviFasbRl5ZB`,
	"chipGroup": `nJDS02D6AU0YgibJ`
};
export default ___CSS_LOADER_EXPORT___;
